<ng-container *ngIf="url || error; else loader">
  <img [alt]="fileId" [src]="url" *ngIf="url" />

  <div class="error" *ngIf="error">
    <span>{{ error }}</span>
  </div>
</ng-container>

<ng-template #loader>
  <q9-content-loader></q9-content-loader>
</ng-template>
